import { useEffect, useState } from "react";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as BackIcon } from "../../../../assets/svg/icons/back.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { useTranslation } from "react-i18next";

interface InfoProductIncomingProps {
  task: ITaskProductIncoming | undefined;
}

export default function InfoProductIncoming(task: InfoProductIncomingProps) {
  const { t } = useTranslation();
  const [taskProductIncoming, setTaskProductIncoming] = useState<ITaskProductIncoming>();
  const hasSkipReason = taskProductIncoming?.skip_reason != null;
  const isBagged = taskProductIncoming?.packaging_type === "BAGGED";

  useEffect(() => {
    setTaskProductIncoming(task.task)
  }, [task.task]);

  return (
    <>
      <MessageBalloon text={t("messageBalloon.receivedProduct")} />

      <div className="containerQuestion">
        <MessageBalloon text={t("messageBalloon.taskCompleted")} pointed />
        <ButtonYesOrNo onlyResult optionSelected={hasSkipReason ? "no" : "yes"} />
      </div>

      {hasSkipReason ?
        <MessageBalloon text={`${taskProductIncoming?.skip_reason}`} answer />
        :
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

            <MessageBalloon
              text={`${t("productPackaging.packaging")}: ${t(isBagged ? "formsV2.packagingBagged" : "formsV2.packagingBulk")}`}
            />
            <MessageBalloon text={`${taskProductIncoming?.sub_classification} - ${taskProductIncoming?.classification} - ${taskProductIncoming?.manufacturer}`} pointed />
            {isBagged && (
              <MessageBalloon
                text={`${t("formsV2.bagWeight")}: ${taskProductIncoming?.bag_weight_kg ?? 0} kg`}
              />
            )}
            <CounterInputV2
              name="info-product-incoming-ordered"
              label={t("productPackaging.orderedQuantity")}
              suffix={isBagged ? t("productPackaging.bags") : "kg"}
              value={String(isBagged
                ? taskProductIncoming?.ordered_bag_quantity_equivalent ?? 0
                : taskProductIncoming?.quantity_ordered_kg ?? 0)}
              description={isBagged
                ? t("productPackaging.kgEquivalent", { value: taskProductIncoming?.quantity_ordered_kg ?? 0 })
                : undefined}
              allowDecimal
              disabled
            />
          </div>

          <CounterInputV2
            name="info-product-incoming-received"
            label={t("productPackaging.receivedQuantity")}
            suffix={isBagged ? t("productPackaging.bags") : "kg"}
            value={String(isBagged
              ? taskProductIncoming?.received_bag_quantity_equivalent ?? 0
              : taskProductIncoming?.quantity_received_kg ?? 0)}
            description={isBagged
              ? t("productPackaging.kgEquivalent", { value: taskProductIncoming?.quantity_received_kg ?? 0 })
              : undefined}
            allowDecimal
            disabled
          />
        </>
      }
    </>
  )
}
